/**
 * Decode a JWT token and return the payload
 * @param token - The JWT token string
 * @returns The decoded payload or null if invalid
 */
export function decodeJWT(token: string): any {
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) {
            return null;
        }
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Error decoding JWT:', error);
        return null;
    }
}

/**
 * Check if the token has a specific role in realm_access
 * @param token - The JWT token string
 * @param role - The role to check for
 * @returns True if the role exists, false otherwise
 */
export function hasRole(token: string | null, role: string): boolean {
    if (!token) {
        return false;
    }

    const decoded = decodeJWT(token);
    if (!decoded || !decoded.realm_access || !decoded.realm_access.roles) {
        return false;
    }

    return decoded.realm_access.roles.includes(role);
}

/**
 * Get all roles from the token
 * @param token - The JWT token string
 * @returns Array of roles or empty array if none found
 */
export function getRoles(token: string | null): string[] {
    if (!token) {
        return [];
    }

    const decoded = decodeJWT(token);
    if (!decoded || !decoded.realm_access || !decoded.realm_access.roles) {
        return [];
    }

    return decoded.realm_access.roles;
}

